<template>
  <div id="noticebox" class="notice">
    <el-card>
      <el-collapse v-model="activeNames" @change="handleChange">
        <el-collapse-item v-for="(item,index) in noticeArray" :key="item.id" :title="item.title" :name="index">
         <div v-html="item.content"></div> 
        </el-collapse-item>
        <!-- <el-collapse-item title="反馈 Feedback" name="2">
          <div>控制反馈：通过界面样式和交互动效让用户可以清晰的感知自己的操作；</div>
          <div>页面反馈：操作后，通过页面元素的变化清晰地展现当前状态。</div>
        </el-collapse-item>
        <el-collapse-item title="效率 Efficiency" name="3">
          <div>简化流程：设计简洁直观的操作流程；</div>
          <div>清晰明确：语言表达清晰且表意明确，让用户快速理解进而作出决策；</div>
          <div>帮助用户识别：界面简单直白，让用户快速识别而非回忆，减少用户记忆负担。</div>
        </el-collapse-item>
        <el-collapse-item title="可控 Controllability" name="4">
          <div>用户决策：根据场景可给予用户操作建议或安全提示，但不能代替用户进行决策；</div>
          <div>结果可控：用户可以自由的进行操作，包括撤销、回退和终止当前操作等。</div>
        </el-collapse-item> -->
      </el-collapse>
    </el-card>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      showHeight: document.documentElement.clientHeight ,// 实时屏幕高度
      activeNames: ['0'],
      noticeArray:[]
    };
  },
  methods: {
      handleChange(val) {
        console.log(val);
      },
      getOnlineNotice:async function(){
        var res = await this.$http.get('/v1/notice/getOnlineNotice')
        var {code,data,message} = res.data
        if(code == 0){
          this.noticeArray = data
          console.log(data)
        }
      }
  },
  mounted: function() {
    this.getOnlineNotice();
    var box = document.getElementById("noticebox");
    //   console.log(box)
    box.style.height = this.showHeight + "px";
    //   console.log(this.showHeight)
    // window.setInterval(()=>{
    //   setTimeout(()=>{
    //     this.getOnlineNotice();
    //   },0)
    // },5000)
  },
  watch:{
    // noticeArray:{
    //   handler:function(newValue,oldValue){
    //     console.log('旧的公告列表',oldValue)
    //     console.log('公告更新',newValue)
    //   },
    //   deep:true,
    // }
  }
};
</script>

<style scoped lang="scss">
.notice {
  width: 1200px;
  margin: 0 auto;
//   background-color: #fff;
  margin-top: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/home/notice/notice.vue